import { combineReducers } from '@reduxjs/toolkit';
import selectedItems from './selectedItemsSlice';
import filterValues from './filterValuesSlice';
import paginationTables from './paginationTablesSlice';
import sortTables from './orderTablesSlice';

const reducer = combineReducers({
  selectedItems,
  filterValues,
  paginationTables,
  sortTables,
});

export const userConfigsSelectors = {
  selectedItems: ({ userConfigs }, object) => userConfigs.selectedItems[object],
  filterValues: ({ userConfigs }, object) => userConfigs.filterValues[object],
  paginationTables: ({ userConfigs }, object) => userConfigs.paginationTables[object],
  sortTables: ({ userConfigs }, object) => userConfigs.sortTables[object],
}

export default reducer;



// WEBPACK FOOTER //
// ./src/store/userConfigs/index.js